import { useMemo } from 'react';

// Generic hook to check if user is in restricted states
export const useRestrictedState = (userLocation) => {
  return useMemo(() => {
    try {
      if (!userLocation || userLocation === "unknown") {
        return false;
      }
      
      const locationData = JSON.parse(userLocation);
      const countryCode = locationData?.countryCode;
      const zipcode = locationData?.zipcode;
      
      if (!zipcode) return false;
      
      const zip3 = zipcode.substring(0, 3);
      
      // Handle Puerto Rico separately (country code might be PR instead of US)
      if (countryCode === "PR" || (countryCode === "US" && zip3 >= '006' && zip3 <= '009')) {
        return true;
      }
      
      // For other US states, check country code is US
      if (countryCode !== "US") {
        return false;
      }
      
      const restrictedZipRanges = {
        'MA': (zip) => zip >= '010' && zip <= '027',
        'NV': (zip) => zip >= '890' && zip <= '898',
        'NM': (zip) => zip >= '870' && zip <= '884',
        'NY': (zip) => zip >= '100' && zip <= '149',
        'OK': (zip) => zip >= '730' && zip <= '749'
      };
      
      for (const [state, checkRange] of Object.entries(restrictedZipRanges)) {
        if (checkRange(zip3)) {
          return true;
        }
      }
      
      return false;
    } catch (error) {
      return false;
    }
  }, [userLocation]);
};

// Hook for header logo selection based on location
const useLogoByLocation = (userLocation) => {
  const isRestricted = useRestrictedState(userLocation);
  
  return useMemo(() => {
    return isRestricted ? "angelai-life-logo-black" : "angelai-life-logo-approved-black";
  }, [isRestricted]);
};

// Hook for footer logo selection based on location
export const useFooterLogoByLocation = (userLocation) => {
  const isRestricted = useRestrictedState(userLocation);
  
  return useMemo(() => {
    return isRestricted ? "angelai-life-logo" : "angelai-life-logo-approved";
  }, [isRestricted]);
};

// Hook for HeaderSubpage logo selection based on location
export const useSubpageLogoByLocation = (userLocation) => {
  const isRestricted = useRestrictedState(userLocation);
  
  return useMemo(() => {
    return isRestricted ? "angelai-life-logo" : "angelai-life-logo-approved";
  }, [isRestricted]);
};

export default useLogoByLocation;